// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host.overflow-scroll .dialog-content {
  overflow-y: auto !important;
  display: block !important;
  padding-right: 10px;
}
:host.overflow-inherit .dialog-content {
  overflow-y: inherit !important;
  overflow-x: inherit !important;
}
:host.overflow-visible .dialog-content {
  overflow: visible !important;
}
@media screen and (max-width: 991px) {
  :host.wide-on-mobile .dialog-content {
    width: 105%;
  }
}
@media screen and (max-width: 850px) {
  :host.mobile-invoice-layout .dialog-panel {
    padding: 20px 0px 20px 20px;
  }
}
@media screen and (max-width: 850px) {
  :host.mobile-invoice-layout .dialog-content {
    padding-right: 20px;
    max-height: calc(95vh - 155px);
  }
}
:host.center-content .dialog-content {
  text-align: center;
}

.dialog-header {
  position: relative;
  border-bottom: 1px solid rgb(229, 229, 229);
  padding-bottom: 15px;
}
.dialog-header .dialog-title {
  margin-top: 5px;
  font-size: 24px;
}
@media screen and (max-width: 500px) {
  .dialog-header .dialog-title {
    font-size: 18px;
  }
}
.dialog-header .dialog-description {
  margin-top: 5px;
  font-size: 14px;
}

.dialog-actions {
  gap: 10px;
}

.dialog-panel {
  box-shadow: 0px 0px 30px rgba(174, 174, 174, 0.5);
  padding: 20px;
  background-color: white;
  border-radius: 4px;
  position: relative;
}

.dialog-content {
  display: block;
  margin-top: 20px;
  font-size: 16px;
  max-height: calc(95vh - 225px);
  overflow-y: auto;
  overflow-x: hidden;
}
.dialog-content .inner-dialog-content {
  width: 100%;
}

.icon-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 18px;
  height: 18px;
  z-index: 9;
  cursor: pointer;
}
.icon-close svg {
  width: 18px;
  height: 18px;
}

.page-indicator {
  color: black;
  position: absolute;
  right: 0px;
  bottom: 0px;
  font-weight: 400;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
